<div>
  <!-- 閉じるボタン -->
  <button
    id="close-btn"
    class="!tw-absolute tw-top-2 tw-right-2 !tw-flex !tw-z-10"
    mat-icon-button
    mat-dialog-close
  >
    <mat-icon class="tw-text-white">close</mat-icon>
  </button>

  <div
    mat-dialog-title
    class="!tw-flex tw-items-center !tw-pt-2 !tw-text-white"
    [ngClass]="titleClass"
  >
    <mat-icon class="tw-text-[3rem] !tw-h-12 !tw-w-12 tw-mr-4 matp-fill-icon">
      {{ titleIcon }}
    </mat-icon>
    <span class="tw-text-[2rem]">{{ title }}</span>
  </div>

  <mat-dialog-content
    class="tw-w-full tw-whitespace-pre-wrap !tw-text-xl tw-justify-center !tw-p-8 !tw-pb-12"
  >
    <span>{{ message }}</span>
  </mat-dialog-content>

  <mat-dialog-actions align="center" class="!tw-pb-5">
    <button
      mat-raised-button
      mat-dialog-close
      class="!tw-min-w-40 tw-my-0 tw-mx-3"
    >
      <mat-icon>close</mat-icon>
      {{ operation ? "キャンセル" : "閉じる" }}
    </button>

    @if (operation) {
      <button
        mat-raised-button
        [color]="operationBtnColor"
        class="!tw-min-w-40 tw-my-0 tw-mx-3"
        (click)="doOperation()"
      >
        <mat-icon>done</mat-icon>
        {{ operation }}
      </button>
    }
  </mat-dialog-actions>
</div>
